<div class="layout-footer">
    <img src="../../assets/layout/images/{{appMain.config.dark ? 'yourlogo_white' : 'yourlogo_dark'}}.png" alt="Logo" height="20" class="mr-2" />
</div>
